import PropTypes from 'prop-types';
import styles from './spinner.css';


const Spinner = ({
  customClass,
}) => (
  <div className={`${styles.spinner} ${customClass || ''}`}>
    <div className={styles.bounce1} />
    <div className={styles.bounce2} />
    <div className={styles.bounce3} />
  </div>
);

Spinner.propTypes = {
  customClass: PropTypes.string,
};

export default Spinner;
